import { Link } from "react-router-dom";

interface FounderFooterLinkProps {
  className?: string;
}

const FounderFooterLink = ({ className = "text-[14px] text-text-muted hover:text-brand transition-colors" }: FounderFooterLinkProps) => (
  <Link to="/sobre" className={className}>
    Sobre a fundadora
  </Link>
);

export default FounderFooterLink;